module.exports = __webpack_public_path__ + "img/logoPokedex.25a8f165.png";